import { useCallback, useMemo } from 'react'
import { generateClient } from 'aws-amplify/api'

import {
  getTeamBidsByYear as getTeamBidsByYearQuery,
  getMyActiveClients as getMyActiveClientsQuery,
} from '../graphql/queries'
import { awardBidWinner } from '../graphql/mutations'

export const useBids = () => {
  const client = useMemo(() => generateClient(), [])
  const getTeamBidsByYear = useCallback(
    async (teamId, bidYear) => {
      return client.graphql({
        query: getTeamBidsByYearQuery,
        variables: { teamId, bidYear },
      })
    },
    [client],
  )

  const awardBid = useCallback(
    async (
      offeringId,
      bidId,
      bidYear,
      wonTeamId,
      targetId,
      lob1,
      winningReason,
      agreedFee,
    ) => {
      return client.graphql({
        query: awardBidWinner,
        variables: {
          input: {
            offeringId,
            bidId,
            bidYear,
            wonTeamId,
            targetId,
            lob1,
            winningReason,
            agreedFee,
          },
        },
      })
    },
    [client],
  )

  const getMyActiveClients = useCallback(
    async (bidYear, teamId) => {
      return client.graphql({
        query: getMyActiveClientsQuery,
        variables: { bidYear, teamId },
      })
    },
    [client],
  )

  return {
    getTeamBidsByYear,
    awardBid,
    getMyActiveClients,
  }
}
